<template>
    <a-modal
      title="添加沟通记录"
      :confirmLoading="loading"
      :destroyOnClose="true"
      v-model="visible"
      @ok="handleOk"
    >
      <a-form :form="form">
        <a-form-item label="上传沟通附件" v-bind="formItemsLayout">
            <a-upload
            name="file"
            :multiple="true"
            accept=".pdf,.doc,.docx,image/jpeg,image/jpg,image/png,.zip,.rar"
            :action="baseURL + '/common/file/upload'"
            :data="{ token: token }"
              v-decorator="[
              'attachment',
              {
                getValueFromEvent: normFile,
                rules: [{ required: true, message: '请上传沟通附件'}]
              }
            ]"
          >
            <a-button>
              <a-icon type="link" /> 点击上传沟通记录
            </a-button>
          </a-upload>
        </a-form-item>
        <div class="des">
          <div style="color:black;font-size: 14px;">请填写附件标题</div>
          <div style="color:#666666;font-size: 12px;">提交后的文件夹将生成文件夹并按照填写信息命名</div>
          <a-form-item>
          <a-input
          v-decorator="[
            'zip_name',
            { rules: [{ required: true, message: '请填写附件标题' }] },
          ]"
        >
        </a-input>
          </a-form-item>
        </div>
      </a-form>
    </a-modal>
  </template>
  
  <script>
  import Api from "@/api";
  let baseURL = process.env.VUE_APP_BASEURL;
  import { mapState } from "vuex";
  export default {
    name: "AddAttachmentModal",
    data() {
      return {
        visible: false,
        baseURL: baseURL,
        formItemsLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 },
      },
        attachment: [],
        fileList:[],
        file:[],
        loading: false,
        record: {},
        form: this.$form.createForm(this),
      };
    },
    computed: {
    ...mapState(["token"])
  },
    methods: {
      show(record) {
        this.record = { ...record };
        this.visible = true;
      },
      close() {
        this.visible = false;
      },
      normFile(info) {
      console.log("Upload event:", info);
      if (Array.isArray(info)) {
        return info;
      }
      this.fileList = info.fileList
      const status = info.file.status;
      if (status === "done") {
        this.$message.success(`${info.file.name} 上传成功！`);
        this.file = [];
        info.fileList.forEach(item => {
          if (item.response && item.response.data) {
            this.file.push(item.response.data);
          }
        });
        console.log(this.file)
      } else if (status === "error") {
        this.$message.error(`${info.file.name} 上传失败！`);
      }
      return info && info.fileList;
    },
    remove (file) {
      let index = this.fileList.indexOf(file)
      this.fileList.splice(index,1)
    },
      handleOk() {
        this.attachment = []
        console.log('111111',this.attachment)
        this.form.validateFields(async (err, values) => {
          if (!err) {
            this.loading = true;
            for(var i = 0;i< this.fileList.length;i++) {
              this.attachment.push({url:this.fileList[i].response.data.url,name:this.fileList[i].response.data.name,time:this.fileList[i].response.data.time})
          }
          let post_id = this.$store.state.post_id;
            try {
              await Api.order.communicateAttach({
              zip_name:values.zip_name,
              post_id: post_id,
              attachment: this.attachment
              });
              this.close();
              this.$emit("ok");
            } catch (e) {}
            this.loading = false;
          }
        });
      },
    },
  };
  </script>
<style lang="scss" scoped>
.des {
  padding: 10px;
  padding-bottom: 0;
  border: 1px solid #dad3d3;
}
::v-deep.ant-form-item {
  margin-bottom: 15px
}
::v-deep.ant-upload-list-item-info {
  height: 100%;
    padding: 0 30px 0 4px;
    -webkit-transition: background-color 0.3s;
    transition: background-color 0.3s;
}
::v-deep.ant-upload-list-item-card-actions {
    position: absolute;
    right: 0;
    opacity: 1;
}
::v-deepa {
  display: inline-block;
    width: 30px;
    text-align: center;
}
::v-deep.ant-input {
  // display: inline-block;
  //   width: 30px;
  //   text-align: center;
  border-radius: 0;
  border-top: 0;
  border-right: 0;
  border-left: 0
}
</style>